import { isValidTimeRange } from "../../../global/utility/scheduleTimeUtils";

export const validateSchedules = (step2) => {
  const attrKeys = Object.keys(step2).filter((k) => k !== "autoResolveForAllAlert");
  for (const key of attrKeys) {
    const attr = step2[key];
    if (!attr?.schedule) continue;
    const { daysEnabled, days, timeEnabled, fromTime, toTime } = attr.schedule;
    if (daysEnabled && (!Array.isArray(days) || days.length === 0)) {
      return { isValid: false, attrKey: key, reason: "noDaysSelected" };
    }
    if (timeEnabled && fromTime && toTime && !isValidTimeRange(fromTime, toTime)) {
      return { isValid: false, attrKey: key, reason: "invalidTimeRange" };
    }
  }
  return { isValid: true, attrKey: null, reason: null };
};

const FieldToValueConverter = (str) => {
  let val = str;
  const regex = /[A-Z]/g;
  const upperCaseLetters = str.match(regex);

  if (Array.isArray(upperCaseLetters) && upperCaseLetters.length > 0) {
    upperCaseLetters.forEach((upperCaseLetter) => {
      val = val.replaceAll(upperCaseLetter, ` ${upperCaseLetter}`);
    });
  }

  return `${val[0].toUpperCase()}${val.substring(1)}`;
};

const IsRequiredValidation = (field, value) => {
  let validator = {
    isValid: true,
    class: "",
    error: "",
  };

  const fieldToVal = FieldToValueConverter(field);
  if(field!=="alertgroup"){
  if (typeof value !== 'string') {
    value = String(value); 
  }
  if(value?.trim() === "" || value?.trim() === undefined){
    validator = {
      ...validator,
      isValid: false,
      class: "shipment-form-field-error",
      error: `${fieldToVal} is required`,
    };
    return validator;
  }
  if (value?.trim()?.length < 1) {
    validator = {
      ...validator,
      isValid: false,
      class: "shipment-form-field-error",
      error: `${fieldToVal} is required`,
    };
    return validator;
  }
}

  validator = {
    ...validator,
    isValid: true,
    class: "shipment-form-field-success",
    error: "",
  };
  return validator;
};

export { IsRequiredValidation };
